export enum ProductLocations {
	Main = 'main', // -> detail
	Sticky = 'sticky', // -> detail -> sticky
	Grid = 'list', // -> plp, favorites?, search?
	Search = 'search_results', // -> search?
	Carousel = 'product-carousel', // -> ??
	FashionAssistant = 'fashion-assistant', // -> fashion assistant
	CrossSellingSimilars = 'pdp-cross-selling:similars',
	CrossSellingTotalLook = 'pdp-cross-selling:total-look',
	CrossSellingPersonalization = 'pdp-cross-selling:recommended',
	CrossSellingLastViewed = 'pdp-cross-selling:last-viewed',
	CrossSellingCollaborativeRecommendations = 'favorite-cross-selling:collaborative-recommendations',
}
